<template>
  <!-- 分享弹窗 -->
  <div class="share" v-show="show_share" @touchmove.prevent>
    <div class="mask"></div>
    <div
      class="content"
      :class="{
        content_ipad: is_ipad,
        show_share: show_share,
        show_share_ipad: show_share && is_ipad,
      }"
    >
      <img
        class="share_content"
        crossorigin="Anonymous"
        src="../img/share-banner.png"
        alt
      />
      <!-- <img
        class="share_content"
        crossorigin="Anonymous"
        src="../img/platform_icon.png"
        alt
      /> -->
      <div class="close_share" @click="close">
        <img src="../img/close-share.png" alt />
      </div>
      <div class="btn_container">
        <div class="share_tips">分享给好友</div>
        <div class="btn_layout">
          <div class="share_btn" @click="share">
            <img src="../img/share-btn.png" alt />
            <div class="btn_tips">分享</div>
          </div>
          <div class="save_btn" @click="saveImg">
            <img src="../img/save-btn.png" alt />
            <div class="btn_tips">保存到相册</div>
          </div>
        </div>
      </div>
    </div>

    <img style="display: none" src="../img/wx-share-icon.png" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { shareInitParam, shareParam } from "../js/params";
import { shareInit, share } from "../js/share";

import { kkmhSDk } from "@/assets/js/SDK_copy/kkmh.sdk.js";

import hybrid from "@kk/hybrid";
import { save_jpeg_image_base64 } from "@kk/h5-sdk";

const { log } = console;

export default {
  data() {
    return {
      save_done: false,
    };
  },
  mounted: function () {
    // 分享初始化
    this.shareInt();
  },
  computed: {
    ...mapState(["show_share", "is_ipad", "app_version"]),
  },
  watch: {
    show_share: function () {
      if (this.show_share) {
        setTimeout(() => {
          this.share();
        }, 200);
      }
    },
  },
  methods: {
    ...mapMutations(["SET_SHOW_SHARE", "SET_SHOW_LOADING"]),
    // 分享初始化
    shareInt() {
      shareInit(this, shareInitParam);
    },
    // 唤起app分享
    share() {
      const { title, desc, imgurl } = shareParam;
      let platform = [
        { name: "QQ", type: 2, link: "", image: imgurl, title: "", desc: "" },
        {
          name: "WechatMoments",
          type: 2,
          link: location.href,
          image: imgurl,
          title: title,
          desc: desc,
        },
        {
          name: "SinaWeibo",
          type: 2,
          link: location.href,
          image: imgurl,
          title: title,
          desc: desc,
        },
        { name: "QZone", type: 2, link: location.href, image: imgurl },
        { name: "Wechat", type: 2, link: location.href, image: imgurl },
      ];
      //判断参数是否存在
      let params = {
        title: title, //分享 标题
        desc: desc, //分享 内容
        link: location.href, //分享 链接
        image: imgurl, //分享 图片
        platform: platform, //分享 类型
        action: { type: 1 }, //分享 执行动作
        extraParams: {}, //分享 辅助通用字段
        h5_tips: false, //分享 是否使用H5分享成功/失败的提示弹
      };

      //新协议
      kkmhSDk.hybrid({
        schema: "kkmhhybrid",
        tagname: "share",
        param: params,
        success: (res) => {
          log("分享成功", res);
        },
        error: (err) => {
          log("分享出错", err);
        },
      });

      this.$doTrack({ name: "图片分享" });
    },
    // 显示全局loading
    showLoading() {
      this.SET_SHOW_LOADING(true);
    },
    // 隐藏全局loading
    hideLoading() {
      this.SET_SHOW_LOADING(false);
    },
    // 检查app版本
    checkAppVersion() {
      return this.app_version > 559000 ? true : false;
    },
    // 点击保存图片
    saveImg() {
      // 5.59以下提示升级app
      if (!this.checkAppVersion()) {
        this.$showToast("app版本过低，请升级后使用本功能");
        return false;
      }
      let img = document.querySelector(".share_content");
      this.showLoading();
      (async () => {
        let base64 = await this.cerateBase64(img);
        await this.saveToLocal(base64);
      })();

      this.$doTrack({ name: "保存到相册" });
    },
    // 生成base64
    cerateBase64(img) {
      // NOTICE:canvas生成图片可能不清楚，进行适当放大
      let imgbase64 = "",
        canvas = document.createElement("canvas"),
        width = img.width,
        height = img.height;
      canvas.width = width * 4;
      canvas.height = height * 4;
      let ctx = canvas.getContext("2d");
      ctx.scale(4, 4);
      ctx.drawImage(img, 0, 0, width, height);
      imgbase64 = canvas.toDataURL();
      // console.log("生成base64---", imgbase64);
      canvas = null;
      return Promise.resolve(imgbase64);
    },
    // 保存到本地
    saveToLocal(base64) {
      let curOs = window.__gvalkkmh.ua.iphone ? "ios" : "android";
      let osType = { ios: this.saveToIos, android: this.saveToAndroid };

      this.save_done = false;
      // 调用保存协议
      // osType[curOs](base64);

      save_jpeg_image_base64({
        img: document.querySelector(".share_content"),
        callback: (res) => {
          console.log("保存图片协议返回", res);
          res.code == 200 ? this.saveImgSuccess() : this.saveImgFail();
        },
      });

      // // 处理有些版本保存协议未知问题
      // setTimeout(() => {
      //   !this.save_done && this.saveWrong();
      // }, 5000);
    },
    // ios保存图片协议
    saveToIos(base64) {
      const saveKey = "unitMemberSaveImg";
      localStorage.setItem(saveKey, null);
      localStorage.setItem(saveKey, base64);

      this.$kkmh.requestHybrid({
        schema: "kkmhhybrid",
        tagname: "localstorage_transfer",

        param: {
          key: saveKey,
          type: 1,
        },
        callback: (res) => {
          log("保存图片---", res);
          res.code == 200 ? this.saveImgSuccess() : this.saveImgFail();
        },
      });
    },
    // android保存图片协议
    saveToAndroid(base64) {
      new Promise((resolve, reject) => {
        let saveResult = window.kkmh.saveJpegImageBase64(
          base64.split("base64,")[1]
        );
        if (saveResult) {
          this.saveImgSuccess();
        } else {
          this.saveImgFail();
        }
      });
    },
    // 图片保存成功
    saveImgSuccess() {
      setTimeout(() => {
        this.hideLoading();
        this.$showToast("图片保存成功，可在手机相册中查看");
        this.save_done = true;
      }, 1000);
    },
    // 图片保存失败
    saveImgFail() {
      setTimeout(() => {
        this.hideLoading();
        this.$showToast("图片保存失败，请重试");
        this.save_done = true;
      }, 1000);
    },
    // 保存协议出问题
    saveWrong() {
      this.hideLoading();
      // this.$showToast("图片保存失败啦，分享试试～");
      this.share();
    },
    // 关闭弹窗
    close() {
      this.SET_SHOW_SHARE(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.share {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}
.content {
  @include boxsize(540, 864);
  @include hcenter(540);
  // @include vcenter(864);
  position: absolute;
  top: 15%;
  transform: scale(0);
  .close_share {
    @include boxsize(58, 58);
    position: absolute;
    top: trans(-16);
    right: trans(-20);
    img {
      width: 100%;
      display: block;
    }
  }
  .share_content {
    width: 100%;
    display: block;
    border-radius: trans(25);
  }
  .btn_container {
    width: trans(540);
    position: absolute;
    bottom: trans(-190);
    .share_tips {
      @include fontstyle(#fdf7e7, 28);
      text-align: center;
      line-height: 1.15;
    }
    .btn_layout {
      @include boxsize(358, 96);
      // @include layout(space-between, center);
      @include layout(center, center);
      margin: 0 auto;
      margin-top: trans(24);
    }
    .share_btn {
      @include boxsize(96, 96);
      @include layout(center, center);

      img {
        width: 100%;
        display: block;
      }
    }
    .save_btn {
      @include boxsize(96, 96);
      @include layout(center, center);
      // display: none;
      img {
        width: 100%;
        display: block;
      }
    }
    .btn_tips {
      @include fontstyle(#fdf7e7, 24);
      white-space: nowrap;
      line-height: 1.15;
      margin-top: trans(18);
    }
  }
}
.content_ipad {
  top: 2%;
}
.show_share {
  animation: shareScale 0.2s 0.2s ease-in-out both;
}
@keyframes shareScale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.show_share_ipad {
  animation: shareScaleIpad 0.2s 0.2s ease-in-out both;
}
@keyframes shareScaleIpad {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(0.8);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/Share.vue